import "backbone-associations";
import "underscore";
import { AppSettings } from "../../app-settings";
import { prop } from "../../decorators/property";
import { autoinject } from "aurelia-dependency-injection";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { BrowsePanelModel } from "../models/browse-panel";

@autoinject
@backboneModelProperties({
    urlRoot: AppSettings.SearchApiUrlPrefix + "search",
    relations: [{
        type: Backbone.Many,
        key: "Panels",
        relatedModel: Backbone.AssociatedModel
    }],
    defaults: {
        Panels: []
    }
})
export class BrowseModel extends Backbone.AssociatedModel {

    @prop() public Loading: boolean;
    @prop() public Panels: Backbone.Collection<BrowsePanelModel>;
    @prop() public PanelsShiftValue: number;
    @prop() public MaxPanels: number;
    @prop() public PanelWidth: number;

    constructor(options?) {
        super(options);
        this.PanelWidth = 310; // Panel width plus margin
    }

    public setupPanels(urlSegments?: string[]) {
        const updatedPanelCount = urlSegments.length;
        this.Panels.remove(this.Panels.rest(updatedPanelCount));
        let i = 0;
        for (const urlSegment of urlSegments) {
            const type = this.getTypeFromUrlSegment(urlSegment);
            const value = this.getValueFromUrlSegment(urlSegment);
            const existingCorrespondingPanel = this.Panels.at(i);

            if (existingCorrespondingPanel) {
                if (existingCorrespondingPanel.SelectedType === type) {
                    existingCorrespondingPanel.Value = value;
                } else {
                    this.Panels.remove(existingCorrespondingPanel);
                    const model = this.createModel(urlSegment);
                    this.Panels.add(model);
                }
            } else {
                const model = this.createModel(urlSegment);
                this.Panels.add(model);
            }
            i++;
        }
        if (this.Panels.last().Value) {
            const newLastPanel = this.createModel();
            this.Panels.add(newLastPanel);
        }
        this.setPanelShift();
    }

    public setPanelShift() {
        this.PanelsShiftValue = -(Math.max(this.Panels.size() - this.MaxPanels, 0) * this.PanelWidth);
    }

    private setupTypeChangeListener(model: BrowsePanelModel) {
        this.listenTo(model.PreRequisites, "change:SelectedType", () => {
            const idx = this.Panels.indexOf(model);
            if (idx === -1) {
                return;
            }
            this.Panels.remove(this.Panels.rest(idx));
        });
    }

    private createModel(urlSegment?: string): BrowsePanelModel {
        const model = new BrowsePanelModel();
        this.Panels.each((panel) => {
            model.PreRequisites.add(panel);
            this.setupTypeChangeListener(model);
        });
        if (urlSegment) {
            this.buildModelFromUrlSegment(urlSegment, model);
        } else {
            this.buildEmptyModel(model);
        }
        return model;
    }

    private buildEmptyModel(model: BrowsePanelModel) {
        model.SelectedType = this.calculateDefaultType(model);
    }

    private calculateDefaultType(model: BrowsePanelModel): string  {
        const preceding = model.PreRequisites.last();
        const yearFieldTaken = model.PreRequisites.any((m) => m.SelectedType === "year");
        const materialFieldTaken = model.PreRequisites.any((m) => m.SelectedType === "material");
        const courtFieldTaken = model.PreRequisites.any((m) => m.SelectedType === "court");
        const jurisdictionFieldCount = model.PreRequisites.where((m) => m.SelectedType === "jurisdiction").length;

        switch (preceding.SelectedType) {
            case "jurisdiction":
                return jurisdictionFieldCount === 1 ? "jurisdiction" : "court";
            case "category":
                return "category";
            case "year":
                return (!materialFieldTaken && !courtFieldTaken) ? "material" : "category";
            case "court":
                return !yearFieldTaken ? "year" : "category";
            default:
                return "category";
        }
    }

    private  getTypeFromUrlSegment(urlSegment: string): string {
        const parts = urlSegment.split("_");
        return parts[0];
    }

    private getValueFromUrlSegment(urlSegment: string): number {
        const parts = urlSegment.split("_");
        return Number(parts[1]);
    }

    private buildModelFromUrlSegment(urlSegment: string, model: BrowsePanelModel): BrowsePanelModel {
        model.id = urlSegment;
        model.SelectedType = this.getTypeFromUrlSegment(urlSegment);
        model.Value = this.getValueFromUrlSegment(urlSegment);
        return model;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/old-browse/models/browse.ts